
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as stripeDbsdokfrs8Rbt2aQpPjwH6lZ3sdBaSM9d7hSNvBZNFAMeta } from "/app/pages/stripe.vue?macro=true";
import { default as callbackpP4QV_45aDBAaDodrISXkTgcnAismuCak5ttSJOC_45p1sMMeta } from "/app/pages/callback.vue?macro=true";
import { default as ordersetRd5nVzxwzOFKlET_Srnu_lQg8OjZqnzEkYxtDM_ACsYMeta } from "/app/pages/orderset.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as indexlYcu4N9sv4FGZHQeTpP6SjPSlylyOGF2nS3PYfXaWVkMeta } from "/app/pages/modules/index.vue?macro=true";
import { default as newHgHHGW1qW9Rx1rnYm03it_p1siTs8A9elLxaCWhMdqsMeta } from "/app/pages/admin/cases/new.vue?macro=true";
import { default as newYR_45disuH94MBFLFBgoeNlSUyCtP_45yeEqti4LtJjFNsgMeta } from "/app/pages/admin/users/new.vue?macro=true";
import { default as indexOjtyWCxdBJeE7x2UbRbZ7wAuYBGKaFNVqO_lHuDSBy0Meta } from "/app/pages/live-room/index.vue?macro=true";
import { default as _91id_93jIhxd1c47LhBmhWbHQcdwqN3zuG_1Sn_E2fAyn8ANrsMeta } from "/app/pages/admin/users/[id].vue?macro=true";
import { default as indexUFdh4ZG8iM2OZp2TwsOA2joFG49W_QKaNRfb_45M9ogwIMeta } from "/app/pages/admin/cases/index.vue?macro=true";
import { default as newX5Yl1P3o1gCqxk7HbB3sTDBi3851QUJJ32mLZVFH9DEMeta } from "/app/pages/admin/modules/new.vue?macro=true";
import { default as newi4nm_8SSC8k2cRw7_45tkBl8NTwO9qN8ftm7KbA76_454ZkMeta } from "/app/pages/admin/patients/new.vue?macro=true";
import { default as download_45dataBDNda4pUJPiVJ5IXiTS4urjRq3_452zGMFEU3_OzvoJ0wMeta } from "/app/pages/admin/download-data.vue?macro=true";
import { default as index6fqcmsk_t1TTJeU3URbiKkjYkPVJQXjjDwFmc7hNstEMeta } from "/app/pages/admin/modules/index.vue?macro=true";
import { default as _91caseId_93ziFckee0f_idmhX6tIB0h69NfVPGCdwKsyGsFhwCp3wMeta } from "/app/pages/admin/cases/[caseId].vue?macro=true";
import { default as index_S3uPA87szqUDxJ0WQje18VCvpkShyEkiPQXMZYGX7kMeta } from "/app/pages/admin/patients/index.vue?macro=true";
import { default as _91roomCode_93KY79m_45Ev3dTC0xvR1Ei4QW7SukybqWYYif4x9pSHxmoMeta } from "/app/pages/live-room/[roomCode].vue?macro=true";
import { default as indexv8EAklLFShZV7xsGMEUeJKTrcYCMYGPQJ30jM17D1tAMeta } from "/app/pages/admin/ecommerce/index.vue?macro=true";
import { default as index6f0gyNtUAxBsSAw5FfKOWRnYLKNIP_45egwmnWirBgE6gMeta } from "/app/pages/admin/live-room/index.vue?macro=true";
import { default as indexjoe_45kG7083wtL0Dq_45ObM1lr6nXnESGyq4XWiA6Cc6A8Meta } from "/app/pages/blocks/[blockId]/index.vue?macro=true";
import { default as _91moduleId_93mY1kZz3XpkLqZF_45ew5K45htY605n82gMP1pIBzQu14gMeta } from "/app/pages/modules/buy/[moduleId].vue?macro=true";
import { default as _91moduleId_93bRmZYqZrrdPKZYIdqZ3SPcvpYfRtyC1CeC0bnSFA434Meta } from "/app/pages/modules/view/[moduleId].vue?macro=true";
import { default as neweiEcZQw_45s6BVgjMQ4w11PO9QT72xOwX01IeTJu_45HwccMeta } from "/app/pages/admin/case-templates/new.vue?macro=true";
import { default as _91moduleId_93acxnuNWQTth9Ueggqvgdrz4tdmaK_y_455ByWgZGj41OAMeta } from "/app/pages/admin/modules/[moduleId].vue?macro=true";
import { default as _91caseId_93_45nC1koT29LhVxBEbvUMb2dEgowpPlxaqjdCccbqqJrIMeta } from "/app/pages/admin/cases/edit/[caseId].vue?macro=true";
import { default as indexkHCueQ3frP0QWEFno5epm4gv5Uu7bP7hPdmV_nFpGUAMeta } from "/app/pages/admin/case-templates/index.vue?macro=true";
import { default as _91roomCode_93rL_YP8gEGvknNjLgBgHnUrTik1RY862krw7kE4DlnhgMeta } from "/app/pages/admin/live-room/[roomCode].vue?macro=true";
import { default as _91patientId_93KT9N1Df2EW5HUcbX_6wQKq8HYgh0o5KzQ5pDibjrrRMMeta } from "/app/pages/admin/patients/[patientId].vue?macro=true";
import { default as _91caseId_93_459_ziC17SdrYeONCvkzDLbTk45wGzqAOvVdu4DUgT4gMeta } from "/app/pages/admin/case-templates/[caseId].vue?macro=true";
import { default as _91moduleId_93hHGJyyWYT9pglh8og1fMtTe8tu1pMdyiYo_Qj0CRcxwMeta } from "/app/pages/admin/modules/edit/[moduleId].vue?macro=true";
import { default as _91patientId_93vl_Y_455lfxslXjL4_o2q3OmpfRG6ZIXlDRmy9WJ7W53IMeta } from "/app/pages/admin/patients/edit/[patientId].vue?macro=true";
import { default as _91caseId_93aoTepFp6bWOrmuxxvrgXeVrtBdksno8BFTPkK2eoV_kMeta } from "/app/pages/admin/case-templates/edit/[caseId].vue?macro=true";
import { default as patients_45consultuj3707FafLLro_45SC8cMXxDSdzByTQ5sHiBSqdrBgpeMMeta } from "/app/pages/blocks/[blockId]/[startedBlockId]/patients-consult.vue?macro=true";
import { default as patients_45trackboardXrMUFnkRxsu9h7D056lFhcieNXPVXc4_45YoU4QTRntPwMeta } from "/app/pages/blocks/[blockId]/[startedBlockId]/patients-trackboard.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "stripe",
    path: "/stripe",
    component: () => import("/app/pages/stripe.vue")
  },
  {
    name: "callback",
    path: "/callback",
    component: () => import("/app/pages/callback.vue")
  },
  {
    name: "orderset",
    path: "/orderset",
    component: () => import("/app/pages/orderset.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "modules",
    path: "/modules",
    component: () => import("/app/pages/modules/index.vue")
  },
  {
    name: "admin-cases-new",
    path: "/admin/cases/new",
    meta: newHgHHGW1qW9Rx1rnYm03it_p1siTs8A9elLxaCWhMdqsMeta || {},
    component: () => import("/app/pages/admin/cases/new.vue")
  },
  {
    name: "admin-users-new",
    path: "/admin/users/new",
    meta: newYR_45disuH94MBFLFBgoeNlSUyCtP_45yeEqti4LtJjFNsgMeta || {},
    component: () => import("/app/pages/admin/users/new.vue")
  },
  {
    name: "live-room",
    path: "/live-room",
    component: () => import("/app/pages/live-room/index.vue")
  },
  {
    name: "admin-users-id",
    path: "/admin/users/:id()",
    meta: _91id_93jIhxd1c47LhBmhWbHQcdwqN3zuG_1Sn_E2fAyn8ANrsMeta || {},
    component: () => import("/app/pages/admin/users/[id].vue")
  },
  {
    name: "admin-cases",
    path: "/admin/cases",
    meta: indexUFdh4ZG8iM2OZp2TwsOA2joFG49W_QKaNRfb_45M9ogwIMeta || {},
    component: () => import("/app/pages/admin/cases/index.vue")
  },
  {
    name: "admin-modules-new",
    path: "/admin/modules/new",
    meta: newX5Yl1P3o1gCqxk7HbB3sTDBi3851QUJJ32mLZVFH9DEMeta || {},
    component: () => import("/app/pages/admin/modules/new.vue")
  },
  {
    name: "admin-patients-new",
    path: "/admin/patients/new",
    meta: newi4nm_8SSC8k2cRw7_45tkBl8NTwO9qN8ftm7KbA76_454ZkMeta || {},
    component: () => import("/app/pages/admin/patients/new.vue")
  },
  {
    name: "admin-download-data",
    path: "/admin/download-data",
    meta: download_45dataBDNda4pUJPiVJ5IXiTS4urjRq3_452zGMFEU3_OzvoJ0wMeta || {},
    component: () => import("/app/pages/admin/download-data.vue")
  },
  {
    name: "admin-modules",
    path: "/admin/modules",
    meta: index6fqcmsk_t1TTJeU3URbiKkjYkPVJQXjjDwFmc7hNstEMeta || {},
    component: () => import("/app/pages/admin/modules/index.vue")
  },
  {
    name: "admin-cases-caseId",
    path: "/admin/cases/:caseId()",
    meta: _91caseId_93ziFckee0f_idmhX6tIB0h69NfVPGCdwKsyGsFhwCp3wMeta || {},
    component: () => import("/app/pages/admin/cases/[caseId].vue")
  },
  {
    name: "admin-patients",
    path: "/admin/patients",
    meta: index_S3uPA87szqUDxJ0WQje18VCvpkShyEkiPQXMZYGX7kMeta || {},
    component: () => import("/app/pages/admin/patients/index.vue")
  },
  {
    name: "live-room-roomCode",
    path: "/live-room/:roomCode()",
    component: () => import("/app/pages/live-room/[roomCode].vue")
  },
  {
    name: "admin-ecommerce",
    path: "/admin/ecommerce",
    meta: indexv8EAklLFShZV7xsGMEUeJKTrcYCMYGPQJ30jM17D1tAMeta || {},
    component: () => import("/app/pages/admin/ecommerce/index.vue")
  },
  {
    name: "admin-live-room",
    path: "/admin/live-room",
    meta: index6f0gyNtUAxBsSAw5FfKOWRnYLKNIP_45egwmnWirBgE6gMeta || {},
    component: () => import("/app/pages/admin/live-room/index.vue")
  },
  {
    name: "blocks-blockId",
    path: "/blocks/:blockId()",
    meta: indexjoe_45kG7083wtL0Dq_45ObM1lr6nXnESGyq4XWiA6Cc6A8Meta || {},
    component: () => import("/app/pages/blocks/[blockId]/index.vue")
  },
  {
    name: "modules-buy-moduleId",
    path: "/modules/buy/:moduleId()",
    component: () => import("/app/pages/modules/buy/[moduleId].vue")
  },
  {
    name: "modules-view-moduleId",
    path: "/modules/view/:moduleId()",
    component: () => import("/app/pages/modules/view/[moduleId].vue")
  },
  {
    name: "admin-case-templates-new",
    path: "/admin/case-templates/new",
    meta: neweiEcZQw_45s6BVgjMQ4w11PO9QT72xOwX01IeTJu_45HwccMeta || {},
    component: () => import("/app/pages/admin/case-templates/new.vue")
  },
  {
    name: "admin-modules-moduleId",
    path: "/admin/modules/:moduleId()",
    meta: _91moduleId_93acxnuNWQTth9Ueggqvgdrz4tdmaK_y_455ByWgZGj41OAMeta || {},
    component: () => import("/app/pages/admin/modules/[moduleId].vue")
  },
  {
    name: "admin-cases-edit-caseId",
    path: "/admin/cases/edit/:caseId()",
    meta: _91caseId_93_45nC1koT29LhVxBEbvUMb2dEgowpPlxaqjdCccbqqJrIMeta || {},
    component: () => import("/app/pages/admin/cases/edit/[caseId].vue")
  },
  {
    name: "admin-case-templates",
    path: "/admin/case-templates",
    meta: indexkHCueQ3frP0QWEFno5epm4gv5Uu7bP7hPdmV_nFpGUAMeta || {},
    component: () => import("/app/pages/admin/case-templates/index.vue")
  },
  {
    name: "admin-live-room-roomCode",
    path: "/admin/live-room/:roomCode()",
    meta: _91roomCode_93rL_YP8gEGvknNjLgBgHnUrTik1RY862krw7kE4DlnhgMeta || {},
    component: () => import("/app/pages/admin/live-room/[roomCode].vue")
  },
  {
    name: "admin-patients-patientId",
    path: "/admin/patients/:patientId()",
    meta: _91patientId_93KT9N1Df2EW5HUcbX_6wQKq8HYgh0o5KzQ5pDibjrrRMMeta || {},
    component: () => import("/app/pages/admin/patients/[patientId].vue")
  },
  {
    name: "admin-case-templates-caseId",
    path: "/admin/case-templates/:caseId()",
    meta: _91caseId_93_459_ziC17SdrYeONCvkzDLbTk45wGzqAOvVdu4DUgT4gMeta || {},
    component: () => import("/app/pages/admin/case-templates/[caseId].vue")
  },
  {
    name: "admin-modules-edit-moduleId",
    path: "/admin/modules/edit/:moduleId()",
    meta: _91moduleId_93hHGJyyWYT9pglh8og1fMtTe8tu1pMdyiYo_Qj0CRcxwMeta || {},
    component: () => import("/app/pages/admin/modules/edit/[moduleId].vue")
  },
  {
    name: "admin-patients-edit-patientId",
    path: "/admin/patients/edit/:patientId()",
    meta: _91patientId_93vl_Y_455lfxslXjL4_o2q3OmpfRG6ZIXlDRmy9WJ7W53IMeta || {},
    component: () => import("/app/pages/admin/patients/edit/[patientId].vue")
  },
  {
    name: "admin-case-templates-edit-caseId",
    path: "/admin/case-templates/edit/:caseId()",
    meta: _91caseId_93aoTepFp6bWOrmuxxvrgXeVrtBdksno8BFTPkK2eoV_kMeta || {},
    component: () => import("/app/pages/admin/case-templates/edit/[caseId].vue")
  },
  {
    name: "blocks-blockId-startedBlockId-patients-consult",
    path: "/blocks/:blockId()/:startedBlockId()/patients-consult",
    meta: patients_45consultuj3707FafLLro_45SC8cMXxDSdzByTQ5sHiBSqdrBgpeMMeta || {},
    component: () => import("/app/pages/blocks/[blockId]/[startedBlockId]/patients-consult.vue")
  },
  {
    name: "blocks-blockId-startedBlockId-patients-trackboard",
    path: "/blocks/:blockId()/:startedBlockId()/patients-trackboard",
    meta: patients_45trackboardXrMUFnkRxsu9h7D056lFhcieNXPVXc4_45YoU4QTRntPwMeta || {},
    component: () => import("/app/pages/blocks/[blockId]/[startedBlockId]/patients-trackboard.vue")
  }
]